/*global ScrollMagic */
import React from 'react'
import styled, { css } from 'styled-components'
import ScrollMagic from 'ScrollMagic'

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
`

const Cards = styled.div`
  position: absolute;
  bottom: 0;
  left: 155px;
  ${props =>
    props.cardsFlyoutNumber === 2 &&
    css`
      left: 130px;
    `}
`

const Card = styled.img`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  max-height: 200px;
  width: auto;
  transition: transform 0.8s ease;
  transition-delay: 0.5s;
  transform: translateX(-100px);
  z-index: 10;
  will-change: transform;

  ${props =>
    props.shown &&
    css`
      transform: translateX(${props => props.number * 35}px);
      transition-delay: ${props => props.number * 0.15}s;
      z-index: ${props => 10 - props.number};
    `}

  ${props =>
    props.shown &&
    props.cardsFlyoutNumber === 2 &&
    css`
      transform: translateX(${props => props.number * 60}px);
    `}
`

class CardsFlyout extends React.Component {
  state = {
    shown: false,
  }

  constructor(props) {
    super(props)
    this.controller = new ScrollMagic.Controller()
  }

  componentDidMount() {
    new ScrollMagic.Scene({
      triggerHook: 0,
    })
      // .removeIndicators()
      // .addIndicators()
      .addTo(this.controller)
      .on('enter', () => {
        this.setState({ shown: true })
      })
  }

  render() {
    const { cards, cardsFlyoutNumber } = this.props

    return (
      <Wrapper>
        <Cards cardsFlyoutNumber={cardsFlyoutNumber}>
          {cards.map((card, index) => (
            <Card
              key={index}
              src={card.src}
              srcSet={card.srcSet}
              width={card.width}
              height={card.height}
              alt=""
              number={index + 1}
              shown={this.state.shown}
              cardsFlyoutNumber={cardsFlyoutNumber}
            />
          ))}
        </Cards>
      </Wrapper>
    )
  }
}

export default CardsFlyout
